module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan4-2-e43e83d326f36921a07bb9fbf7271ac2.webp";